import React, { useEffect, useState } from "react";
import Button from "../../../../components/Common/Button/Button";
import QuizImage from "../../../../components/Manage/QuizImage/QuizImage";
import { useCheckList } from "../../../../hooks/useCheckList";
import { useFetchData } from "../../../../hooks/useFetchData";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";
import {
  deleteQuizImagesActionHandler,
  getExistingQuizImagesActionHandler,
  getQuizImagesActionHandler,
  postMultiQuizImagesActionHandler,
} from "../../../../store/actions/actionHandlers/manageActionHandler";
import classes from "./QuizImages.module.scss";
import Input from "../../../../components/Common/Input/Input";
import Modal from "../../../../components/Common/Modal/Modal";
import { setErrorHandler } from "../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../utils/errorTypes";
import Loader from "../../../../components/Common/Loader/Loader";
import loaders from "../../../../store/actions/actionCreators/loadersActionCreator";
import { FormattedMessage } from "react-intl";
const QuizImages = () => {
  const pageSize = 15;
  const dispatch = useDispatch();

  const manageState = useSelector((state) => state.manageReducer);
  const { deleteQuizImagesLoader, uploadQuizImagesLoader } = manageState;
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;

  const methods = useForm({});
  const { reset } = methods;

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    loading,
    handleCurrentPage,
    handleSearchQuery,
  } = useFetchData(getQuizImagesActionHandler, pageSize);

  const [hasMoreData, setHasMoreData] = useState(true);
  const [imageFiles, setImageFiles] = useState({});
  const [isDelete, setIsDelete] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isReplaceModal, setIsReplaceModal] = useState(false);
  useEffect(() => {
    if (data?.length >= totalRows) {
      setHasMoreData(false);
    } else {
      setHasMoreData(true);
    }
    let counter = 0;
    data.forEach((row) => {
      if (row.checked) {
        counter++;
      }
    });
    if (counter > 0) {
      setIsDelete(true);
    } else {
      setIsDelete(false);
    }
  }, [data, totalRows]);

  const { checkedAll, handleCheckAll, handleCheckOne } = useCheckList(
    "Mediaid",
    data,
    setData,
    setUpdatedData
  );

  const { ref } = useInfiniteScroll(handleCurrentPage, hasMoreData);

  const handleReplaceModal = () => {
    setIsReplaceModal(!isReplaceModal);
  };
  const handleDeleteModal = () => {
    setIsDeleteModal(!isDeleteModal);
  };
  const handleDeleteBulkUploadImage = () => {
    dispatch(
      deleteQuizImagesActionHandler(data, updatedData, setData, setUpdatedData)
    ).then(() => {
      handleDeleteModal();
    });
  };

  const handleBulkUmagesUpload = (e) => {
    let files = e.target.files;

    const filesSupported = ["png", "gif", "jpg", "bmp"];
    let valid = true;
    [...files].forEach((file) => {
      let lastIndexVal = (file?.name.lastIndexOf(".") - 1) >>> 0;
      let fileExtension = file?.name.slice(lastIndexVal + 2);
      if (!filesSupported.includes(fileExtension)) {
        valid = false;
        dispatch(
          setErrorHandler(errorTypes.WARN, `Please select a valid format`)
        );
        return;
      }
    });

    if (!valid) {
      reset();
      return;
    }

    setImageFiles(() => files);
    if (files.length < 5) {
      dispatch(loaders.manage.contentBulkUpload.uploadQuizImagesLoader(true));
      dispatch(getExistingQuizImagesActionHandler(files)).then(
        (isMediaExists) => {
          if (isMediaExists) {
            handleReplaceModal();
            dispatch(
              loaders.manage.contentBulkUpload.uploadQuizImagesLoader(false)
            );
          } else {
            dispatch(postMultiQuizImagesActionHandler(files)).then(
              (isUploaded) => {
                if (isUploaded) {
                  dispatch(
                    setErrorHandler(
                      errorTypes.SUCCESS,
                      `Images are uploaded successfully`
                    )
                  );
                  dispatch(
                    loaders.manage.contentBulkUpload.uploadQuizImagesLoader(
                      false
                    )
                  );
                  handleSearchQuery();
                }
              }
            );
          }
        }
      );
    } else {
      dispatch(
        setErrorHandler(
          errorTypes.WARN,
          `Maximum of 4 images can be selected at a time`
        )
      );
    }
    reset();
  };
  const handleReplaceBulkUploadImage = () => {
    dispatch(loaders.manage.contentBulkUpload.uploadQuizImagesLoader(true));
    dispatch(postMultiQuizImagesActionHandler(imageFiles)).then(
      (isUploaded) => {
        if (isUploaded) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Images are uploaded successfully`
            )
          );
          dispatch(
            loaders.manage.contentBulkUpload.uploadQuizImagesLoader(false)
          );
          handleSearchQuery();
        }
        handleReplaceModal();
      }
    );
  };
  return (
    <div className={classes.quizImages}>
      <FormProvider {...methods}>
        <div className={classes.quizImages__checkAll}>
          <Button
            label={<FormattedMessage id="DISTRIBUTE_DELETE" />}
            type="button"
            onClick={handleDeleteModal}
            backgroundColor={colors.red}
            width="10.5"
            height="4"
            dark
            borderRadius="0.7"
            disabled={!isDelete}
            loading={deleteQuizImagesLoader}
          />
          <Input
            label={<FormattedMessage id="SELECT_ALL" />}
            name="selectAll"
            type={"checkbox"}
            checked={checkedAll}
            onChange={handleCheckAll}
            height="2"
            width="2"
            direction="row-reverse"
          />
        </div>
        <div className={classes.quizImages__imageList} ref={ref}>
          {data?.length > 0 ? (
            <div className={classes.quizImages__imageList__main}>
              {data.map((image) => {
                return (
                  <QuizImage
                    image={image}
                    name={"MultiSelectImages"}
                    key={image.Mediaid}
                    value={image.checked}
                    fieldValue="Mediaid"
                    handleClick={handleCheckOne}
                  />
                );
              })}
            </div>
          ) : loading ? (
            <div className={classes.quizImages__imageList__loading}>
              <div className={classes.quizImages__imageList__loading__loader}>
                <Loader />
              </div>
            </div>
          ) : (
            <h1 className={classes.quizImages__imageList__noImages}>
              <FormattedMessage id="NO_IMAGES" />
            </h1>
          )}
        </div>
      </FormProvider>
      <div className={classes.quizImages__footer}>
        <div>* Format Supported .png, .jpg, .gif, .bmp</div>
        <div><FormattedMessage id="QUIZ_IMAGE_UPLOAD_LIMIT_MSG" /></div>
        <FormProvider {...methods}>
          <Input
            name="bulkUploadImages"
            type="file"
            onChange={handleBulkUmagesUpload}
            accept="image/png, image/gif, image/jpg,image/bmp"
            hidden={true}
            isLight={false}
            gap="0"
            placeholder={"Upload New"}
            multiple
            loading={uploadQuizImagesLoader}
          />
        </FormProvider>
      </div>
      <Modal
        handleSubmit={handleReplaceBulkUploadImage}
        isOpen={isReplaceModal}
        heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
        toggle={handleReplaceModal}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        width={"46.2"}
        height={"26.9"}
        canClose={false}
        loading={uploadQuizImagesLoader}
      >
        <div className={classes.quizImages__deleteModal}>
          <div className={classes.quizImages__deleteModal__text}>
            <FormattedMessage id="IMAGE_EXISTS" />
          </div>
        </div>
      </Modal>
      <Modal
        handleSubmit={handleDeleteBulkUploadImage}
        isOpen={isDeleteModal}
        heading={<FormattedMessage id="USERGROUP_DELETEGRP__HEADERMSG" />}
        toggle={handleDeleteModal}
        buttonLabel1={<FormattedMessage id="YES_TEXT" />}
        buttonLabel2={<FormattedMessage id="USERGRP_CANCELBTN_TEXT" />}
        width={"46.2"}
        height={"26.9"}
        loading={deleteQuizImagesLoader}
      >
        <div className={classes.quizImages__deleteModal}>
          <div className={classes.quizImages__deleteModal__text}>
            <FormattedMessage id="DELETE_IMAGES_CONFIRM" />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default QuizImages;
